import { useCallback, useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';

import { getCardInfo } from './getCardInfo';
import { CardInfo } from './types';

const INITIAL_DATA = null;

export const useBinacle = () => {
  const [data, setData] = useState<typeof INITIAL_DATA | CardInfo>(
    INITIAL_DATA,
  );
  const [isLoading, setIsLoading] = useState(false);
  const { setError, clearErrors } = useFormContext();

  const getCardInfoRequest = useCallback(async (bin: string) => {
    setIsLoading(true);

    try {
      const { data: nextData } = await getCardInfo(bin);

      clearErrors('root.binacle');
      setData(nextData);
    } catch {
      setData(INITIAL_DATA);
      setError('root.binacle', {
        message: 'Card is not supported',
      });
    } finally {
      setIsLoading(false);
    }
  }, [clearErrors, setError]);

  useEffect(() => () => {
    clearErrors('root.binacle');
  }, [clearErrors]);

  const resetCardInfo = useCallback(() => {
    setData(INITIAL_DATA);
    clearErrors('root.binacle');
  }, [clearErrors]);

  return {
    data,
    getCardInfo: getCardInfoRequest,
    isLoading,
    resetCardInfo,
  };
};
